<template>
  <div class="container-fluid page">
    
    <div class="row flex-grow-1">
      <div class="col-12 mt-4">
        <charity-rota-card v-if="charity" :title="'Rota'" :charity="charity" @charityUpdated="updateCharity"></charity-rota-card>
      </div>
    </div>
    
    <div class="row">
      <div class="col-6 mt-4">
        <details-card :entity="this.charity"></details-card>
      </div>
      <div class="col-6 mt-4">
        <resources-card :resources="resources"></resources-card>
      </div>
    </div>
    
  </div>
</template>

<script>
  // Imports
  import ResourcesCard from '@/components/Cards/ResourcesCard'
  import DetailsCard from '@/components/Cards/DetailsCard'
  import CharityRotaCard from '@/components/Cards/CharityRotaCard'
  import CharitiesService from '../../../services/CharitiesService';
  import UserStore from '../../../services/UserStore'
  //
  export default {
    name: 'charity-your-branch',

    components: {
      ResourcesCard,
      DetailsCard,
      CharityRotaCard
    },

    data() {
      return {
        charity: null,
        resources:[
          { description: 'Support pack', uploadId: 'dashboard_guide-charity' },
          { description: 'Store guide', uploadId: 'store_guide-charity' },
          // {'description': 'Obligations', 'link': 'https://www.fooddrop.co.uk/'},
          { description: 'Terms & conditions', link: 'https://www.fooddrop.co.uk/legal/web-terms-and-conditions' },
          { description: 'Privacy policy', link: 'https://www.fooddrop.co.uk/legal/privacy-policy' },
        ]
      };
    },
    
    created: async function(){
      this.updateCharity();
    },

    methods:{
      updateCharity: async function(){
        try{
          let result = await CharitiesService.getById(UserStore.userData.groupEntityId);
          this.charity = result.data;
        }catch(error){
          console.log(error);
        }
      },
    }
  };
</script>

<style>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }
</style>
